import "./web.set-timeout-72b6430f.js";
import { useRef as i, useEffect as f, useCallback as v } from "react";
import "./export-cdcbfb2b.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
var C = function(n, r) {
  var o = i(n), u = i(), e = i(0);
  f(function() {
    o.current = n;
  }, [n]);
  var t = v(function() {
    u.current && (e.current = 0, clearInterval(u.current));
  }, []), c = v(function() {
    t(), !(!r && r !== 0) && (u.current = setInterval(function() {
      e.current++, o.current(e.current, r * e.current);
    }, r));
  }, [t, r]);
  return f(function() {
    return c(), t;
  }, [c, t]), {
    setInterval: c,
    clearInterval: t
  };
};
export {
  C as useInterval
};
